module.exports = __webpack_public_path__ + "media/icons/carouselArrowNext-56b186ff.svg";